import { useQuery } from '@tanstack/react-query';
import api from '../services/api';
import { API_ROUTES } from '../config/api';

export interface ArticleFilterOptions {
  columns: {
    categorical: string[];
    numeric: string[];
  };
  filters: {
    [key: string]: string[] | { min: number; max: number };
  };
}

export function useArticleFilters(databaseId: number | string | null) {
  return useQuery({
    queryKey: ['articleFilters', databaseId],
    queryFn: async () => {
      if (!databaseId) throw new Error('Database ID is required');
      
      const response = await api.get(
        `${API_ROUTES.DB_MANAGER.BASE}${API_ROUTES.DB_MANAGER.ARTICLE_FILTERS(databaseId)}`
      );
      
      return response.data as ArticleFilterOptions;
    },
    enabled: !!databaseId,
    staleTime: 1000 * 60 * 10, // 10 minutes (les filtres changent moins souvent)
  });
} 